import { useEffect, useState } from "react"
import { UnfilteredIcd } from "@fusion-advantage/backcompat"
import { V2L3ListSearchModal } from "../ListSearch/V2L3ListSearchModal"
import { drClaudesAlmanac } from "../../../../lib/lorem/DrClaude"
import { useFormDispatch, useFormSelector } from "../../../../redux/formStoreHooks"
import { dismissFormModal, FormModal } from "../../../../redux/formSlice"
import { pushAdhocDxs } from "../../../../redux/diagnosisReviewSlice"
import { useFormAppRelay } from "../../../../lib/relay/FormAppRelay"
import { DiagnosisSource } from "@fusion-advantage/formlib"

// note that with react compiler plugged in, in theory
// we can now be a lot less concerned with explicit memoization and callbacks
// https://react.dev/learn/react-compiler

export const LxAddAdhocDiagnosisModal = () => {
	const { queryUnfilteredIcds } = useFormAppRelay()
	const reviewItems = useFormSelector(state => state.diagnosisReview.models)
	const dispatch = useFormDispatch()
	const [loading, setLoading] = useState(false)
	const [selected, setSelected] = useState<UnfilteredIcd[]>([])
	const [query, setQuery] = useState('')
	const [queryResults, setQueryResults] = useState<UnfilteredIcd[]>([])
	useEffect(() => {
		// on modal load,
		// throw a loading indicator and ensure that the icd list for the
		// date of service in question is loaded
		const load = async () => {
			setLoading(true)
			await queryUnfilteredIcds({icdCodeQuery: 'A'})
			setLoading(false)
		}
		load()
	}, [queryUnfilteredIcds])
	useEffect(() => {
		if(!query) {
			setQueryResults([])
			return
		}
		let cancel = false
		const select = async () => {
			const timeoutId = setTimeout(() => {
				setLoading(true)
			}, 500)
			// for local testing within storybook
			// const icds = drClaudesAlmanac.filter(
			// 	dx => dx.Icd10Code.toUpperCase().startsWith(query.toUpperCase())
			// )
			const r = await queryUnfilteredIcds({icdCodeQuery: query})
			const icds = r.icdCodes
			clearTimeout(timeoutId)
			if(cancel) {
				return
			}
			setLoading(false)
			setQueryResults(icds)
		}
		select()
		return () => {
			cancel = true
		}
	}, [queryUnfilteredIcds, query])
	const reviewAdhocIcds = new Set(
		reviewItems
			.filter(item => item.source === DiagnosisSource.Adhoc)
			.map(item => item.icd10Code)
		)
	const selectedIcds = new Set(selected.map(dx => dx.Icd10Code))
	const displayResults = queryResults
		// do not show if already on review table
		.filter(dx => !reviewAdhocIcds.has(dx.Icd10Code) && !selectedIcds.has(dx.Icd10Code))
	const available = displayResults
		.map((dx) => ({
			title: `[${dx.Icd10Code}] ${dx.Description}`,
			// disabled: selectedIcds.has(dx.icd)
		}))
	const handleDismissClick = () => {
		dispatch(pushAdhocDxs(selected))
		dispatch(dismissFormModal(FormModal.AddAdhocDiagnosis))
	}
	return (
		<V2L3ListSearchModal
			loading={loading}
			title="Add Diagnosis"
			itemsSelected={selected.map(dx => ({title: `[${dx.Icd10Code}] ${dx.Description}`}))}
			itemsAvailable={available}
			query={query}
			onQueryChange={(query) => setQuery(query)}
			onAddClick={(idx) => {
				const item = displayResults[idx]
				if(!selectedIcds.has(item.Icd10Code)) {
					setSelected([
						...selected,
						item,
					])
				}
			}}
			onDropClick={(idx) => {
				const item = selected[idx]
				setSelected(selected.filter(dx => dx.Icd10Code !== item.Icd10Code))
			}}
			onDismissClick={handleDismissClick}
		/>
	)
}
